var _style, _g, _path, _path2, _polygon, _path3, _polygon2, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _polygon3, _path10, _polygon4, _path11, _polygon5, _path12, _path13, _path14, _circle2, _path15, _path16, _polygon6, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFamilienrechtTodErbe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "publicdomainvectors.org",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#F4F4F4;}\n\t.st1{opacity:0.14;fill-rule:evenodd;clip-rule:evenodd;fill:#137F7B;}\n\t.st2{opacity:0.14;fill-rule:evenodd;clip-rule:evenodd;fill:#015B58;}\n\t.st3{opacity:0.15;fill-rule:evenodd;clip-rule:evenodd;fill:#015B58;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#823103;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#4A1B00;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#B5A7A3;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#998B86;}\n\t.st8{fill:#FFB8B8;}\n\t.st9{fill:#2F2E41;}\n\t.st10{fill:#FFB7B7;}\n\t.st11{opacity:0.2;enable-background:new    ;}\n\t.st12{fill:#15151E;}\n\t.st13{fill:#CBCBCB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9865 -0.1637 0.1637 0.9865 -24.9021 42.994)",
    className: "st0",
    cx: 248.4,
    cy: 172.6,
    rx: 150.8,
    ry: 150.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289.3,350.7c-24.8,15.2-71.9,25.5-125.9,25.5c-79.8,0-144.5-22.5-144.5-50.2c0-16.8,23.8-31.7,60.3-40.8 c-1.3-3.1-2-6.2-2-9.4c0-34.3,80.1-62.2,179-62.2c98.9,0,179,27.8,179,62.2c0,12.1-10,23.4-27.3,33c28.4,5.1,47.8,15.4,47.8,27.3 c0,17-39.6,30.7-88.5,30.7C333.5,366.9,304.2,360.3,289.3,350.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M340.7,221.1c56.3,10.5,94.5,31.1,94.5,54.8c0,2.9-0.6,5.7-1.6,8.4l-137.4,52.2c-15.7,2.6-31.5,4.3-47.3,5.1 l-41.2,2.1l103-123.6L340.7,221.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M299.5,400.9c24.4,0,44.2-6.9,44.2-15.4c0-8.5-19.9-15.4-44.2-15.4s-44.2,6.9-44.2,15.4 C255.3,394,275.2,400.9,299.5,400.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.2,291.3c24.4,0,44.2-6.9,44.2-15.4c0-8.5-19.9-15.4-44.2-15.4c-24.4,0-44.2,6.9-44.2,15.4 C33,284.4,52.8,291.3,77.2,291.3z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 465.5,
    cy: 305.5,
    rx: 30.3,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.2,309l16.1-37c3.4-7.8,10-16,18.2-18.4l145.1-41.1c10.8-3,22.6-5.6,33.1-1.9l64,22 c9.9,3.4,15.2,12.4,19.4,22l11.8,27.2L232,337c-24,9.8-50.8,10.4-75.2,1.7L90.2,309z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M324.4,218.1l42.2,14.5c7.4,2.5,12.2,8.2,16,14.9l-15.9,4.9c-8.2-4.8-17.6-7.3-27.1-7.3h-22.3L324.4,218.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M378.5,241.3c3.1,3.9,5.5,8.5,7.5,13.3l11.8,27.2L232,337c-18.2,7.5-38,9.6-57.2,6.4 c1.5-11.7,4.5-23.3,9-34.4c4.2-10.3,12.7-18.2,23.3-21.7L378.5,241.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M343.6,237l7.9-79.9c0.3-6.3-3.5-12.1-9.4-14.3l-42.3-2.6c-1-0.1-2,0.1-3,0.4l-27.2,5.2l21.9,9.9V223 l25.8,22.1L343.6,237z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M317.4,245.2l5.9-82.5c0.3-6.3-3.5-12.1-9.4-14.3l-42.3-2.6c-5.4-0.3-8.9,4.4-8.8,9.7l0.5,73.1L317.4,245.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M289.8,188c6.5,0,11.9-7.5,11.9-16.7c0-9.2-5.3-16.7-11.9-16.7s-11.9,7.5-11.9,16.7 C277.9,180.5,283.2,188,289.8,188z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M270.9,194.1l37.4,1.3l-0.4,12.3l-36.9-4.4L270.9,194.1L270.9,194.1z M270.9,208.8l36.7,4.9l-0.3,12.2 l-36.2-7.9L270.9,208.8z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M408,287.5c-2.8-1.7-3.7-5.3-2-8c0.2-0.3,0.4-0.6,0.6-0.8l-7.6-76.2l12.7,0.8l3.5,75.1c2.3,2.3,2.3,6,0,8.3 C413.3,288.6,410.3,289,408,287.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M416.8,199.6l-3.3,25.3l0.5,15.5l-13.9,1.3l-2.8-12.9l-1.5-34.1c-0.2-5.3,3.7-10,9-10.6l0,0 c5.5-0.6,10.5,3.3,11.3,8.8L416.8,199.6z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "363.4,422 354.9,422 350.9,389.4 363.4,389.4 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M365.5,430.2l-27.3,0v-0.3c0-5.9,4.8-10.6,10.6-10.6h0l16.7,0L365.5,430.2z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "433.2,422 424.8,422 420.8,389.4 433.3,389.4 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M435.4,430.2l-27.3,0v-0.3c0-5.9,4.8-10.6,10.6-10.6h0l16.7,0L435.4,430.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 400.3,
    cy: 153.8,
    r: 18.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M398,179.6l12.7,1.5l0,0c6.3,8.9,7.9,20.3,4.3,30.6l-9.6,27.8c0,0,13.3,26.7,13.3,51.6 c0,24.8,25.4,113.4,25.4,113.4l-35.7,3.7l-15.6-94.4l-21.5,94l-24.5-4l13.5-123.2l8.9-40.6l0.4-19.8c0,0-3.8-14.8,5.7-24.3 l11.6-16.2L398,179.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M386.9,290.6c-2.9-2-3.7-6-1.7-8.9c0.2-0.3,0.5-0.6,0.7-0.9l-3.8-83.8l13.8,1.7l-0.6,82.3 c2.4,2.6,2.2,6.7-0.5,9.1C392.6,292.1,389.3,292.3,386.9,290.6L386.9,290.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M401.8,195l-5.1,27.5l-0.4,17l-15.3,0.6l-2.3-14.3l0.3-37.4c0.1-5.9,4.6-10.7,10.5-11l0,0 c6.1-0.4,11.3,4.2,11.8,10.3L401.8,195z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M379,147.2h27v-11.8c-5.9-2.4-11.7-4.3-15.2,0C384.2,135.5,379,140.7,379,147.2L379,147.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M407.4,133.4c16.1,0,20.6,20.2,20.6,31.6c0,6.4-2.9,8.6-7.4,9.4l-1.6-8.5l-3.7,8.9c-1.3,0-2.6,0-4,0l-1.3-2.6 l-2.8,2.6c-11.3,0-20.5,1.7-20.5-9.7C386.8,153.6,390.7,133.4,407.4,133.4z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "383.6,245 382.9,215.4 381.1,202.2 376.6,215.3 "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M174.1,282.9c0.4-2.9-1.7-5.6-4.7-6c-0.3,0-0.6,0-0.9,0l-5.3-11l-7.5,1.6l7.7,15.5c0.4,3,3,5.1,6,4.7 C171.9,287.3,173.9,285.4,174.1,282.9L174.1,282.9z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "59.1,410.9 65.4,414.1 80.6,391.6 71.4,386.9 "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M58.6,408.1l12.3,6.3l0,0c4.3,2.2,6,7.5,3.8,11.8l-0.1,0.3l-20.1-10.3L58.6,408.1z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "131.1,419.7 138.1,419.7 141.4,392.7 131.1,392.7 "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M129.3,417.4l13.8,0h0c4.9,0,8.8,3.9,8.8,8.8v0.3l-22.6,0L129.3,417.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3,199.4c0,0-4.7-3.6-4.7,5.2l-0.7,29l8.3,27.4l4.8-8.9l-2-19.2L98.3,199.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M148.5,278.7c0,0,5.4,26.5-1.4,48.2l-3.8,83.5l-14-1.1l-4.9-62l-4.7-30.8l-9.8,28.1l-32.3,59.4l-14.9-11.6 c0,0,16.5-44.9,28.6-54.4l6.1-69.5L148.5,278.7z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 132,
    cy: 148.1,
    r: 15.9
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M130.8,151.5c1.9,0.2,3.3-1.7,4-3.5c0.7-1.8,1.2-3.9,2.8-4.9c2.3-1.3,5.2,0.3,7.8-0.2c2.9-0.5,4.8-3.6,5-6.6 c0.1-3-1-5.8-2.2-8.5l-0.4,3.4c0.1-2.3-1-4.6-2.9-5.9l0.5,5c-0.5-2.9-3.2-4.8-6.1-4.4c0,0,0,0,0,0l0.1,3c-3.4-0.5-6.8-0.7-10.2-0.5 c-3.4,0.2-6.7,1.5-9.4,3.6c-3.8,3.3-5.2,8.8-4.8,13.9c0.5,5.1,2.6,9.8,4.7,14.4c0.5,1.2,1.3,2.5,2.6,2.6c1.2,0,2.2-0.8,2.5-1.9 c0.3-1.1,0.3-2.3,0-3.4c-0.5-1.7-0.6-3.4-0.4-5.2c0.3-1.7,1.5-3.4,3.3-3.6c1.7-0.2,3.5,1.8,2.7,3.3L130.8,151.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M116.7,169.8l3.3-4.6c0,0,3.7,1.3,13.7,6.2l0.7,4.3l17.3,106.4l-31.5-1.4l-8.6-0.2l-6.3-0.1l-8.4-0.2L97,249.8 l2.7-23.4l-4.2-22.1c0,0-5.3-20.3,15.1-31.2L116.7,169.8z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "160.3,277.2 161.5,281.2 169.5,276 166.4,272.6 "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M122.7,182.7c0,0,12.4-15.8,19.9,1.8l2.4,18.5c0,0,9.1,23,9.3,32.3c0,0,6.2,12.1,6.1,18.5l9.1,20.6l-9.3,5.8 l-25.8-39.6L122.7,182.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilienrechtTodErbe);
export default __webpack_public_path__ + "static/media/Familienrecht_Tod_Erbe.95c51f5fcf5de4d2a7c7a7b9732b88b0.svg";
export { ForwardRef as ReactComponent };